import { render, staticRenderFns } from "./WithdrawalRecord.vue?vue&type=template&id=3950090f&scoped=true&"
import script from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawalRecord.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalRecord.vue?vue&type=style&index=0&id=3950090f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3950090f",
  null
  
)

export default component.exports